export function modal() {
    const trigger = [...document.querySelectorAll("[data-modal-open]")];
    if (!trigger.length) return;
    const closeTrigger = [...document.querySelectorAll("[data-modal-close]")];

    function open(e) {
        const id = e.currentTarget.dataset.modalOpen;
        const modal = document.querySelector(`[data-modal="${id}"]`);
        document.body.classList.add("-lock");
        modal.classList.add("-active");
    }

    function close(e) {
        const id = e.currentTarget.dataset.modalClose;
        const modal = document.querySelector(`[data-modal="${id}"]`);
        document.body.classList.remove("-lock");
        modal.classList.remove("-active");
    }

    for (const el of trigger) {
        el.addEventListener("click", open);
    }

    for (const el of closeTrigger) {
        el.addEventListener("click", close);
    }
}
